import React, {useState} from 'react';
import { useDispatch, useSelector} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import { Typography } from '@material-ui/core';

import { update_adress } from '../actions/adressAction';
import axiosJsonAdapter from 'axios-jsonp'

//import screen
import Message from './Message';

//import formik and yup
import { useFormik } from 'formik';
import * as yup from 'yup';
import axios from 'axios';



const useStyles = makeStyles((theme) => ({
    button:{
        textAlign:'center',
        color:'black',
        backgroundColor:theme.palette.primary['200'],
        '&:hover':{
            backgroundColor:theme.palette.primary['400']
        }
    },
    card:{
        backgroundColor:'white',
        color: 'black',
        marginTop:theme.spacing(2)
    },
    form: {

    },
    message:{
        merginBottom:theme.spacing(2)
    },
    submit: {

    },
    input_text:{
        color:'black'
    },
    postalcode:{
        marginBottom:theme.spacing(1)
    },    
    text_field:{
        color:'black',
        borderWidth: '1px',
        borderColor:`${theme.palette.primary['500']} !important`,
    },
    title:{
        textAlign:'center',
        marginBottom:theme.spacing(2),
        fontWeight:'bold'
    }
}))

//yup バリデーション
const validationSchema = yup.object({
    prefecture: yup
    .string('')
    .max(20,'20文字以内で入力して下さい')
    .required('入力は必須です'),
    city: yup
    .string('')
    .max(20,'20文字以内で入力して下さい')
    .required('入力は必須です'),
    address: yup
    .string('')
    .max(100, '100文字以内で入力して下さい')
    .required('入力は必須です'),
    building: yup
    .string('')
    .max(100, '100文字以内で入力して下さい')
})

const checkoutValidationSchema = validationSchema.shape({
    first_name: yup.string('').max(15, '15文字以内で入力して下さい').required('入力は必須です'),
    last_name: yup.string('').max(15, '15文字以内で入力して下さい').required('入力は必須です'),
    phone_number: yup.string('').matches(/^\d{8,16}$/, '半角数字8〜16桁で入力して下さい').required('入力は必須です'),
})

const AddressForm = ({collectAccountInfo = false, onSaved}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()
    const {accountPublicInfo = {}} = useSelector(state => state.accountPublicInfo)
    const {adressInfo = {}} = useSelector(state => state.adress)

    const [postalcode, setPostalcode] = useState(adressInfo.postalcode || '');
    const [error, setError] = useState('')

    //郵便番号から住所を取得
    const submitPostalCode =  async (event) => {
        event.preventDefault()
        try{
            if(postalcode.length === 7){
            setError('')
            const config = {'headers': {'Content-Type': 'application/json'}}
            const data = await axios.get(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalcode}`, 
            {adapter:axiosJsonAdapter},config)
            formik.setFieldValue('prefecture', data['data']['results'][0]['address1'])
            formik.setFieldValue('city', data['data']['results'][0]['address2'])
            formik.setFieldValue('address', data['data']['results'][0]['address3'])
            }else{
                setError('郵便番号は７文字で入力して下さい')
            }
        }catch(e){
            setError('郵便番号が見つかりませんでした、もう一度入力して下さい。')
        }
    }
    
    //formik住所更新
    const formik = useFormik({
        initialValues:{
            first_name: accountPublicInfo.first_name || '',
            last_name: accountPublicInfo.last_name || '',
            phone_number: accountPublicInfo.phone_number || '',
            prefecture: adressInfo.prefecture || '',
            city: adressInfo.region || '',
            address: adressInfo.address || '',
            building: adressInfo.building_name || '',
        },
        validationSchema: collectAccountInfo ? checkoutValidationSchema : validationSchema,
        validateOnMount: true,
        onSubmit: async (values) => {
            if(!/^\d{7}$/.test(postalcode)){
                setError('郵便番号は半角数字7桁で入力して下さい')
                return
            }
            setError('')
            const country = 'japan'
            const account = collectAccountInfo ? {
                first_name: values.first_name,
                last_name: values.last_name,
                phone_number: values.phone_number,
            } : {}
            const result = await dispatch(update_adress(country, values.prefecture, values.city, values.address, values.building, postalcode, account))
            if(!result.success){
                setError(result.message)
                return
            }
            if(onSaved){
                onSaved()
            }
            if(location.pathname === '/address_update'){
                navigate(-1)
            }
        }
    })


    return(
        <>
            {error && <Message severity="error">{error}</Message>}
                    <Typography variant='h2' component="h2" className={classes.title}>
                        住所
                    </Typography>
                    <div className={classes.postalcode}>
                        <form className={classes.form} noValidate onSubmit={submitPostalCode}>
                            <Grid container spacing={2}>
                                <Grid item xs={9}>
                                    <TextField
                                    margin='none'
                                    variant="outlined"
                                    color="primary"
                                    required={true}
                                    fullWidth
                                    id="postalcode"
                                    label={postalcode ? '' : "郵便番号"}
                                    name="postalcode"
                                    autoFocus
                                    value={postalcode}
                                    InputLabelProps={{
                                        classes:{
                                            root: classes.input_text
                                        }
                                    }}
                                    InputProps={{
                                        classes:{
                                            notchedOutline:classes.text_field,
                                            root: classes.text_field
                                        }
                                    }}
                                    onChange={(event) => {setPostalcode(event.target.value)}}
                                    />
                                    </Grid>
                                    <Grid item xs={3}>
                                    <Button
                                    type="submit"
                                    variant="contained"
                                    className={classes.button}
                                    >
                                        検索
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                    <form className={classes.form} noValidate onSubmit={formik.handleSubmit}>
                        <Grid container spacing={2}>
                            {collectAccountInfo && <>
                            <Grid item xs={6}>
                                <TextField variant="outlined" required fullWidth id="first_name" label="姓" name="first_name"
                                    value={formik.values.first_name} onChange={formik.handleChange}
                                    error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                                    helperText={formik.touched.first_name && formik.errors.first_name}
                                    InputLabelProps={{classes:{root: classes.input_text}}}
                                    InputProps={{classes:{notchedOutline:classes.text_field, root: classes.text_field}}}/>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField variant="outlined" required fullWidth id="last_name" label="名" name="last_name"
                                    value={formik.values.last_name} onChange={formik.handleChange}
                                    error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                                    helperText={formik.touched.last_name && formik.errors.last_name}
                                    InputLabelProps={{classes:{root: classes.input_text}}}
                                    InputProps={{classes:{notchedOutline:classes.text_field, root: classes.text_field}}}/>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField variant="outlined" required fullWidth id="phone_number" label="電話番号" name="phone_number"
                                    value={formik.values.phone_number} onChange={formik.handleChange}
                                    error={formik.touched.phone_number && Boolean(formik.errors.phone_number)}
                                    helperText={formik.touched.phone_number && formik.errors.phone_number}
                                    InputLabelProps={{classes:{root: classes.input_text}}}
                                    InputProps={{classes:{notchedOutline:classes.text_field, root: classes.text_field}}}/>
                            </Grid>
                            </>}
                            <Grid item xs={6}>
                                <TextField
                                    color='primary'
                                    variant="outlined"
                                    margin="none"
                                    required
                                    fullWidth
                                    id="prefecture"
                                    label="都道府県"
                                    name="prefecture"
                                    autoComplete='prefecture'
                                    value={formik.values.prefecture}
                                    onChange={formik.handleChange}
                                    error={formik.touched.prefecture && Boolean(formik.errors.prefecture)}
                                    helperText={formik.touched.prefecture && formik.errors.prefecture}
                                    InputLabelProps={{
                                        classes:{
                                            root: classes.input_text
                                        }
                                    }}
                                    InputProps={{
                                        classes:{
                                            notchedOutline:classes.text_field,
                                            root: classes.text_field
                                        }
                                    }}
                                />
                            </Grid>
                        <Grid item xs={6}>
                        <TextField
                        variant="outlined"
                        margin="none"
                        required
                        fullWidth
                        id="region"
                        label="市区町村"
                        name="city"
                        value={formik.values.city}
                        onChange={formik.handleChange}
                        error={formik.touched.city && Boolean(formik.errors.city)}
                        helperText={formik.touched.city && formik.errors.city}
                        InputLabelProps={{
                            classes:{
                                root: classes.input_text
                            }
                        }}
                        InputProps={{
                            classes:{
                                notchedOutline:classes.text_field,
                                root: classes.text_field
                            }
                        }}
                        />
                        </Grid>
                        <Grid item xs={12}>
                        <TextField
                        variant="outlined"
                        margin="none"
                        required
                        fullWidth
                        id="address"
                        label="以下の住所"
                        name="address"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        error={formik.touched.address && Boolean(formik.errors.address)}
                        helperText={formik.touched.address && formik.errors.address}
                        InputLabelProps={{
                            classes:{
                                root: classes.input_text
                            }
                        }}
                        InputProps={{
                            classes:{
                                notchedOutline:classes.text_field,
                                root: classes.text_field
                            }
                        }}
                        />
                        </Grid>
                        <Grid item xs={12}>
                        <TextField
                        variant="outlined"
                        margin="none"
                        fullWidth
                        id="building"
                        label="建物名・号室"
                        name="building"
                        value={formik.values.building}
                        onChange={formik.handleChange}
                        error={formik.touched.building && Boolean(formik.errors.building)}
                        helperText={formik.touched.building && formik.errors.building}
                        InputLabelProps={{
                            classes:{
                                root: classes.input_text
                            }
                        }}
                        InputProps={{
                            classes:{
                                notchedOutline:classes.text_field,
                                root: classes.text_field
                            }
                        }}
                        />
                        </Grid>
                        <Grid item xs={12}>
                        <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        disabled={formik.isSubmitting || !formik.isValid || !/^\d{7}$/.test(postalcode)}
                        >
                            {formik.isSubmitting ? '登録中…' : '変更'}
                        </Button>
                        </Grid>
                        </Grid>
                    </form>
        </>

    )
}

export default AddressForm
